import { useEffect } from "react";
import { Link } from "wouter";

export default function DataDeletion() {
  useEffect(() => {
    document.title = "Data Deletion | Codevector Cloud";
  }, []);

  return (
    <main className="h-screen overflow-y-auto bg-background text-foreground">
      <div className="mx-auto max-w-3xl px-6 py-10 sm:py-14">
        <Link
          href="/"
          className="mb-8 inline-flex text-sm font-medium text-primary hover:underline"
        >
          Back to Codevector
        </Link>

        <article className="prose prose-invert max-w-none prose-headings:text-foreground prose-p:text-muted-foreground prose-li:text-muted-foreground prose-a:text-primary">
          <p className="text-sm font-medium uppercase tracking-wide text-primary">
            Meta App Compliance
          </p>
          <h1>User Data Deletion</h1>

          <p>
            To request deletion of data associated with this app, email{" "}
            <a href="mailto:lockogift@gmail.com">lockogift@gmail.com</a> with
            your Threads username and the subject "Data Deletion Request". We
            will process the request within 30 days.
          </p>

          <h2>Data Stored</h2>
          <p>
            This app currently stores only authorization/account identifiers
            needed to publish approved content.
          </p>

          <h2>Contact</h2>
          <p>
            Email:{" "}
            <a href="mailto:lockogift@gmail.com">lockogift@gmail.com</a>
          </p>
        </article>
      </div>
    </main>
  );
}
